module.exports = __webpack_public_path__ + "static/media/icon-high-tide.417d1d10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-high-tide.svg
// module id = 1343
// module chunks = 0